import { AutomaticParkingReportClient, ConfigBasedAdminClient, ExportJobClient, FinanceClientPriceModelClient, FleetListClient, ParkingCardClient, PaymentReportClient, TagMasterClient, UserExtractReportClient } from './../base/models/models.swagger.generated';
import { ParkingSessionService } from './parker-registration/parking-session.service';
import { ParkerRegistrationService } from './parker-registration/parker-registration.service';
import {
  AutomaticParkingScheduleClient,
  DeviceStatusReportClient,
  FalseRecordingsReportClient,
  ParkerExtractReportClient,
  ParkerRegistrationClient,
  ParkerRegistrationReportClient,
  ParkerTagClient,
  ParkerTurnoverReportClient,
  ParkingClient,
  ParkingRangerSessionClient,
  ParkingSubscriptionClient,
  ParkingTariffClient,
  SavedReportClient,
  TagsPerParkerReportClient,
  ZoneDamageClient,
} from '../base/models/models.swagger.generated';
import { ZoneDamageService } from './zone-damage/zone-damage.service';
import { ParkerAdministrationService } from './administration/parker-administration/parker-administraton.service';
import { ClientAdministrationService } from './administration/client-administration/client-administration.service';
import { NgModule } from '@angular/core';
import { CompanyAdministrationService } from './administration/company-administration/company-administration.service';
import { ParkingRangerSessionsService } from './parking-ranger-sessions/parking-ranger-sessions.service';
import { TagsPerParkerReportService } from './reports/report/tags/tags-per-parker-report.service';
import { ParkerRegistrationReportService } from './reports/report/parker-registration/parker-registration-report.service';
import { FalseRecordingReportService } from './reports/report/false-recording/false-recording-report.service';
import { ParkerTurnoverReportService } from './reports/report/parker-turnover/parker-turnover-report.service';
import { ParkerExtractReportService } from './reports/report/parker-extract/parker-extract-report.service';
import { DeviceStatusReportService } from './reports/report/device-status/device-status-report.service';
import { AutomaticParkingReportService } from './reports/report/automatic-parking/automatic-parking-report.service';
import { PaymentReportService } from './reports/report/payment/payment-report.service';
import { ZoneDetailsService } from './administration/administration/administration-details/zone-details/zone-details.service';
import { ZoneDeviceDetailsService } from './administration/administration/administration-details/zone-device-details/zone-device-details.service';
import { TariffDetailsService } from './administration/administration/administration-details/tariff-details/tariff-details.service';
import { SubscriptionDetailsService } from './administration/administration/administration-details/subscription-details/subscription-details.service';
import { UserExtractReportService } from './reports/report/user-extract/user-extract-report.service';
import { FinanceClientPriceModelService } from './administration/client-administration/client-administraion-edit-form/price-model-edit/finance-client-price-model.service';
import { ExportJobService } from './reports/export-jobs/export-job.service';
import { FleetListService } from './administration/fleet-list/fleet-list.service';

@NgModule({
    imports: [
    ],
    providers: [
        ClientAdministrationService,
        CompanyAdministrationService,
        ZoneDetailsService,
        ZoneDeviceDetailsService,
        ParkerRegistrationClient,
        ParkerRegistrationService,
        ParkerAdministrationService,
        ParkerTagClient,
        ZoneDamageService,
        ZoneDamageClient,
        ParkingClient,
        ParkingSessionService,
        ParkingRangerSessionClient,
        ParkingTariffClient,
        ParkingSubscriptionClient,
        ParkingRangerSessionsService,
        TariffDetailsService,
        SubscriptionDetailsService,
        TagsPerParkerReportService,
        ParkerRegistrationReportService,
        FalseRecordingReportService,
        ParkerTurnoverReportService,
        AutomaticParkingReportService,
        PaymentReportService,
        TagsPerParkerReportClient,
        ParkerRegistrationReportClient,
        FalseRecordingsReportClient,
        ParkerTurnoverReportClient,
        ParkerExtractReportClient,
        ParkerExtractReportService,
        UserExtractReportClient,
        UserExtractReportService,
        DeviceStatusReportClient,
        AutomaticParkingReportClient,
        PaymentReportClient,
        SavedReportClient,
        DeviceStatusReportService,
        AutomaticParkingScheduleClient,
        ConfigBasedAdminClient,
        TagMasterClient,
        ParkingCardClient,
        FinanceClientPriceModelClient,
        FinanceClientPriceModelService,
        ExportJobService,
        ExportJobClient,
        FleetListService,
        FleetListClient,
    ],
})
export class DomainModule {
}
